import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface UpdateColaPayload {
  colaAnnual: number;
  colaEligibleDate: string;
}

export interface UpdateColaResponse {
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UpdateColaInfoService {

  constructor(private httpClient: HttpClient) {}

  updateColaInfo(benefitId: string, payload: any): Observable<UpdateColaResponse> {
    const url = `${environment.apiUrl}/new-payroll/annuity-benefits/${benefitId}/cola`;
    return this.httpClient.put<UpdateColaResponse>(url, payload);
  }
}
